import { render, staticRenderFns } from "./90.vue?vue&type=template&id=72be28ff&scoped=true&"
var script = {}
import style0 from "./90.vue?vue&type=style&index=0&id=72be28ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be28ff",
  null
  
)

export default component.exports